import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { TrendingUp, Sparkles, Clock } from "lucide-react";

const Card = ({ p }) => (
  <Link to={`/plans/${p.id}`} data-testid={`hp-plan-${p.id}`} className="group block border border-border bg-card hover:border-accent transition-colors">
    <div className="aspect-[4/3] bg-muted overflow-hidden">
      {p.images?.[0] ? (
        <img src={p.images[0]} alt={p.title} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" draggable={false} onContextMenu={(e) => e.preventDefault()} data-protected="true" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-muted-foreground text-xs">—</div>
      )}
    </div>
    <div className="p-4">
      <div className="overline text-accent">{p.style}</div>
      <div className="font-display text-lg leading-tight mt-1 line-clamp-2">{p.title}</div>
      <div className="text-xs text-muted-foreground mt-1">{p.bedrooms} bd · {p.bathrooms} ba · {p.sqft} sqft</div>
    </div>
  </Link>
);

const Section = ({ title, icon: Icon, plans, testId }) => {
  if (!plans || plans.length === 0) return null;
  return (
    <section className="mt-16 lg:mt-24" data-testid={testId}>
      <div className="flex items-baseline justify-between gap-4 mb-6">
        <div>
          <div className="overline text-accent flex items-center gap-2"><Icon size={12} /> {title}</div>
          <h2 className="font-display text-3xl lg:text-4xl mt-2 tracking-tight">{title}</h2>
        </div>
        <Link to="/plans" className="text-sm text-muted-foreground hover:text-accent whitespace-nowrap">View all →</Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {plans.map((p) => <Card key={p.id} p={p} />)}
      </div>
    </section>
  );
};

const HomeAnalytics = () => {
  const [trending, setTrending] = useState([]);
  const [recent, setRecent] = useState([]);
  const [purchased, setPurchased] = useState([]);

  useEffect(() => {
    api.get("/analytics/trending?limit=6").then((r) => setTrending(r.data)).catch(() => {});
    api.get("/analytics/recently-added?limit=6").then((r) => setRecent(r.data)).catch(() => {});
    api.get("/analytics/recently-purchased?limit=6").then((r) => setPurchased(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <Section title="Trending this week" icon={TrendingUp} plans={trending} testId="hp-trending" />
      <Section title="Recently purchased" icon={Sparkles} plans={purchased} testId="hp-purchased" />
      <Section title="Recently added" icon={Clock} plans={recent} testId="hp-recent" />
    </div>
  );
};

export default HomeAnalytics;
